import flexImages from 'javascript-flex-images';
import lazyElements from "../lazyElements/lazyElements";
import lazyImages from "../lazyImages/lazyImages";
import axios from "axios";
import React, { Fragment, useEffect } from "react";
import ReactDOM from "react-dom";

new flexImages({ selector: '.flex-images', rowHeight: 300 });

let catSections = document.getElementsByClassName('cat-section');

for (let i = 0; i < catSections.length; i++) {
    const section = catSections[i];
    const flexSection = section.querySelector('.flex-container');

    lazyElements(section, function (el) {
        axios.get(
            `/api/portfolio/category/${section.id}`
        ).then(response => {
            ReactDOM.render(<PortfolioItems section={section} {...response} />, flexSection);
        }).catch(

        );
    })
};

const PortfolioItems = props => {

    // Similar to componentDidMount and componentDidUpdate:
    useEffect(() => {
        props.section.classList.add('flex-images');
        new flexImages({ selector: props.section, rowHeight: 300 });
        let images = props.section.querySelectorAll('.lazy-img');
        lazyImages(images);
    });

    return (
        <Fragment>
            {props.data.map((item, key) => (
                item && (
                    <li key={key} className="item" data-w={item.media.size.width} data-h={item.media.size.height} >
                        <div className="il-info position-absolute w-100 h-100 d-flex flex-column py-3 px-3 text-center align-items-center justify-content-center">
                            <p className="h5">{item.title}</p>
                            <a className="btn btn-primary btn-sm" href={`/${item.location_slug}`}>Visit
                                Location</a>
                        </div>
                        <div className="w-100 h-100">
                            <div className="spinner-grow text-secondary position-absolute" role="status">
                                <span className="sr-only">Loading...</span>
                            </div>
                            <picture>
                                <source
                                    type="image/webp"
                                    data-srcset={`${item.media.xs.webp_url} 720w, ${item.media.xss.webp_url} 360w`}
                                    sizes="(min-width: 768px) 25vw, (max-width:767px) 50vw" />
                                <source
                                    type="image/jpeg"
                                    data-srcset={`${item.media.xs.url} 720w, ${item.media.xss.url} 360w`}
                                    sizes="(min-width: 768px) 25vw, (max-width:767px) 50vw" />
                                <img
                                    className="lazy-img"
                                    width={item.media.width}
                                    height={item.media.height}
                                    // loading="lazy"
                                    src={`data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 ${item.media.width} ${item.media.height}'%3E%3C/svg%3E`} alt={item.title} data-src={item.media.url} />
                            </picture>
                        </div>
                    </li>
                )
            ))}
        </Fragment>
    );
}


let yearSections = document.getElementsByClassName('year-section');

for (let i = 0; i < yearSections.length; i++) {
    const section = yearSections[i];
    const flexSection = section.querySelector('.flex-container');

    lazyElements(section, function (el) {
        axios.get(
            `/api/portfolio/year/${section.id}`
        ).then(response => {
            ReactDOM.render(<PortfolioItems section={section} {...response} />, flexSection);
        }).catch(

        );
    })
};
